export enum ActionTypes {
    Delivery = 1,
    Pickup = 2,
  }
